const { throwError } = require('./ab-helpers');
const abTypes = require('./ab-types');

const abPlatform = $ => {
  if (!$) {
    throwError('[abClient] jQuery parameter required');
  }

  const makeData = (platform, environment, domain) => ({
    modifyCounts: {
      experimentModifyCount: -1,
      goalModifyCount: -1
    },
    platform,
    env: environment,
    domain
  });

  const fetchExperimentSummaries = (options, callback) => {
    $.ajax({
      url: options.experimentSummariesUrl,
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(
        makeData(options.platform, options.environment, options.domain)
      ),
      success: data => {
        callback({ type: abTypes.EXPERIMENT_SUMMARIES_FETCHED, payload: data });
      },
      error: (jqXHR, textStatus, errorThrown) => {
        callback({
          type: abTypes.EXPERIMENT_SUMMARIES_ERROR,
          payload: errorThrown
        });
      }
    });
  };

  return {
    fetchExperimentSummaries
  };
};

module.exports = abPlatform;



// WEBPACK FOOTER //
// ./src/ab-platform.js